export default __webpack_public_path__ + "static/shopify_plus_experts-8aacc40735afeeea21fa5133f3b0d3de.svg";